/* eslint-disable no-magic-numbers */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ResponsiveLine } from "@nivo/line";
import numeral from "numeral";
import { abbreviateNumber } from "pages/dealScreener/Email/constants";

const Wrapper = styled.div`
    min-height: 220px;
    max-height: 240px;
    height: calc(100% - 2px);
`;

const ValuationSensitivityChart = ({ valuationSensitivityToCapRate = [], color }) => {
  const [data, setData] = useState([]);
  const [maxYValue, setMaxYValue] = useState(0);
  const [maxXValue, setMaxXValue] = useState(0);
  const [minXValue, setMinXValue] = useState(0);

  useEffect(() => {
    if (valuationSensitivityToCapRate) {
      const formattedData = [
        {
          id: "Data",
          data: valuationSensitivityToCapRate?.map(({ capRate, valuation }) => ({ x: capRate, y: valuation }))
        }
      ];
      setData(formattedData);
      const capRateArr = valuationSensitivityToCapRate?.map(d => d.capRate);
      const valuationsArr = valuationSensitivityToCapRate?.map(d => d.valuation);
      setMaxXValue(Math.max(...capRateArr));
      setMinXValue(Math.min(...capRateArr));
      setMaxYValue(Math.max(...valuationsArr));
    }
  }, [valuationSensitivityToCapRate]);

  return (
    <Wrapper>
      <ResponsiveLine
        data={data}
        height={224}
        width={350}
        curve="basis"
        margin={{ top: 30, right: 30, left: 68, bottom: 30 }}
        yScale={{ type: "linear", max: 1.3 * maxYValue }}
        xScale={{ type: "linear", max: 1.1 * maxXValue, min: minXValue - 0.005 }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 10,
          tickValues: 5,
          format: v => `$${abbreviateNumber(v)}`
        }}
        axisBottom={{
          tickSize: 0,
          tickPadding: 10,
          format: val => `${numeral(val).format("0.00%")}`
        }}
        colors={[`#${color}`]}
        enableGridX={false}
        gridYValues={5}
        enablePointLabel
        pointLabel={l => `$${abbreviateNumber(l.y, true, true)}`}
        theme={{
          axis: {

            domain: {
              line: {
                strokeWidth: 2,
                stroke: `#${color}`
              }
            },
            dots: {
              text: {
                fill: `#${color}`
              }
            },
            ticks: {
              text: {
                fontFamily: "Work Sans",
                letterSpacing: 0,
                color: `#${color}`,
                fontWeight: 300,
                fontSize: 9
              }
            }
          }
        }}
      />
    </Wrapper>
  );
};

export default ValuationSensitivityChart;
